import { Button } from "components/Button/Button";

interface CancelButtonProps {
    onClick: () => void;
    label?: string;
    className?: string;
    variation?: "dark";
    /** Disable the button (e.g. while a sibling submit request is in flight). */
    disabled?: boolean;
    autoFocus?: boolean;
}

export const CancelButton = ({ onClick, label, className, variation, disabled, autoFocus }: CancelButtonProps) => (
    <Button
        variation={variation ?? "white"}
        label={label ?? "Cancel"}
        onClick={onClick}
        className={className ?? ""}
        disabled={disabled}
        autoFocus={autoFocus}
    />
);

export const cancelButtonProps = { className: "button button--white" };
